import styled from 'styled-components'
export const Wrapper = styled.div`
  /* height: 100%; */
  padding: 15px 0px;
  .prev {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: absolute;
    margin-top: -5px;
  }
  .margin {
    margin-top: 30px;
    position: relative;
  }
  .inputWidth {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid rgba(228, 228, 228, 0.6);
    box-sizing: border-box;
    border-radius: 5px;
    height: 50px;
  }
  .VscArrowSmallLeft {
    font-size: 30px;
  }
  .filter {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 20px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      display: block;
    }
  }
  .search-bar {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid rgba(228, 228, 228, 0.6);
    box-sizing: border-box;
    border-radius: 5px;
    display: flex;
    align-items: center;
    position: relative;
    text-align: center;
    width: 40%;
    margin-left: 5px;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 100%;
      margin-left: 0px;
      margin-bottom: 20px;
    }
    /* justify-content: center; */
  }
  .previous {
    font-size: 20px;
    margin-top: 10px;
  }
  .search {
    cursor: pointer;
    position: absolute;
    right: 12px;
    color: ${({ theme }) => theme.colors.primary};
  }
  .filter_select {
    width: 30%;
    height: 42px;
    font-family: ${({ theme }) => theme.colors.gray};
    font-style: normal;
    font-weight: 500;
    font-size: ${({ theme }) => theme.fontSize.x5};
    color: ${({ theme }) => theme.colors.gray};
    opacity: 0.8;
    @media (max-width: ${({ theme }) => theme.responsive.mobile}) {
      width: 50%;
    }
  }

  .spinner_container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 400px;
  }
  .css-16hif6x-control {
    height: 42px !important;
  }
  .status-last {
    background: rgba(190, 147, 17, 0.2);
    border-radius: 40px;
    width: 87px;
    flex: 9%;

    height: 24px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    .para-successful {
      color: #01c715;
      font-size: 12px;
    }
    .para-failed {
      color: #eb5757;
      font-size: 12px;
    }
    .para-processing {
      color: #be9311;
      font-size: 12px;
    }
    .para-cancelled {
      color: #eb5757;
      font-size: 12px;
    }
  }
  .successful {
    background-color: rgba(1, 199, 21, 0.2);
  }
  .failed {
    background-color: rgba(255, 114, 94, 0.2);
  }
  .processing {
    background-color: rgba(190, 147, 17, 0.2);
  }
  .cancelled {
    background-color: rgba(235, 87, 87, 0.1);
  }
`
export const ShowMore = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  .show-page {
    font-family: 'Inter';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.4px;
  }
  .page {
    color: #24292e;
  }
  .arrows {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  img {
    cursor: pointer;
    width: 25px;
  }
`
